import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend'
ajaxFormExtend.init();

import * as projectTeaser from './scripts/project-teaser'
projectTeaser.init();

import * as infiniteGrid from './scripts/infinite-grid'
infiniteGrid.init();

import * as filterGroup from './scripts/filter-group';
filterGroup.init();

import * as copyToClipboard from './scripts/copy-to-clipboard'
copyToClipboard.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
    plugins: ['video']
});

import * as lightboxExtend from './scripts/lightbox-extend';
lightboxExtend.init();